module.exports = __webpack_public_path__ + "static/media/light-green-spot.aa1a4def.png";